import { WhatsappLogo } from "@phosphor-icons/react";

export default function WhatsAppButton() {
  const number = "919462020447";
  const msg = encodeURIComponent("Hello Jashoda Hospital, I'd like to enquire about an appointment.");
  return (
    <a
      href={`https://wa.me/${number}?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-btn"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute -inset-2 rounded-full bg-[#25D366]/30 blur-md opacity-70 group-hover:opacity-100 transition-opacity" />
      <span className="relative flex items-center gap-3 bg-[#25D366] text-white pl-4 pr-5 py-3.5 rounded-full shadow-[0_10px_40px_rgba(37,211,102,0.4)] hover:scale-105 transition-transform">
        <WhatsappLogo size={26} weight="fill" />
        <span className="hidden sm:inline text-sm font-semibold">Chat with us</span>
      </span>
    </a>
  );
}
